import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { AlertService } from 'app/shared/alert/alert.service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { MatDialogRef } from '@angular/material/dialog';
import { DashboardService } from 'app/services/dashboard.service';
import { ShiftDataService } from '../shift-data-analysis/shift-data.service';

@Component({
  selector: 'app-edit-sla-days',
  templateUrl: './edit-sla-days.component.html',
  styleUrls: ['./edit-sla-days.component.scss']
})
export class EditSlaDaysComponent implements OnInit, OnDestroy {
  private _unsubscribeAll: Subject<any> = new Subject<any>();
  public selectedAssetType: any;
  filtersCopy: any[] = [];
  numberOfDays : any = [1,2,3,4,5,6,7];
  public filters: any[] = [];
  newSLADay : number = -1;
  saveBtnEnable : boolean = false;
  constructor(
      public shiftDataService: ShiftDataService,
      public dashboardService: DashboardService,
      private route: ActivatedRoute,
      private alertService: AlertService,
      public dialogRef: MatDialogRef<EditSlaDaysComponent>
  ) {
    //to calculate the time in dashboard to check if user is using the application or not ,if not then logout the user
    this.dashboardService.calculateTime();
  }
    //to calculate the time in dashboard to check if user is using the application or not ,if not then logout the user
    @HostListener('window:mousemove')
    @HostListener('window:keypress')
    @HostListener('window:scroll')
    @HostListener('window:touchstart')
    resetIdleTimer() {
        this.dashboardService.reInitializeTimer();
    }
    
  ngOnInit(): void {
    
          this.getDepartmentDetails();
      this.route.queryParams.subscribe((params: any) => {
          if (params['selectedAssetIdsToEditSlaDays']) {
              this.shiftDataService.selectedAssetIdsToEditSlaDays = JSON.parse(
                  params['selectedAssetIdsToEditSlaDays']
              );
          } else {
              this.shiftDataService.selectedAssetIdsToEditSlaDays = [];
          }
      });
      this.saveBtnEnable = (this.newSLADay > 0 && this.shiftDataService.selectedAssetIdsToEditSlaDays.length > 0) ? false : true ;
    }

  ngOnDestroy(): void {
      // Unsubscribe from all subscriptions
      this._unsubscribeAll.next(null);
      this._unsubscribeAll.complete();
  }

  onSearchFilter(value: any) {
    this.selectedAssetType = undefined;
    if (value) {
        
        this.filters = [
            ...this.filtersCopy.filter((assetType) =>
                assetType.assets.findIndex((asset) =>
                    (asset.asset_name)
                        .replace('_', ' ')
                        .toLowerCase()
                        .includes(value.toLowerCase())
                ) > -1
                    ? assetType
                    : null
            ),
        ];
 
        if (this.filters && this.filters.length) {
            this.selectedAssetType = this.filters[0];
        }
    } else {
        this.filters = [...this.filtersCopy];
        this.selectedAssetType = this.filters[0];
    }
}

  isChecked(asset: any) {
      return !!this.shiftDataService.selectedAssetIdsToEditSlaDays.filter(
          (a) => a.asset_id == asset.asset_id
      ).length;
  }

  onAssetClick(assetType: any) {
      this.selectedAssetType = assetType;
  }

  checkLocalStorage(value:string)
  {
      if(localStorage.getItem(value) !== null){
          return localStorage.getItem(value) === "true" ? true : false;
      }
      else{
          return true;
      }
  }

  department_asset_details = [];

  departmentDetails :any =[];
  getDepartmentDetails(){
    let siteIds :any = [];
    if(this.shiftDataService && this.shiftDataService.selectedSiteSlaData && this.shiftDataService.selectedSiteSlaData[0] 
        && this.shiftDataService.selectedSiteSlaData[0].sub_sites && this.shiftDataService.selectedSiteSlaData[0].sub_sites[0] && 
        this.shiftDataService.selectedSiteSlaData[0].sub_sites[0].site_id && this.shiftDataService.selectedSiteSlaData[0].sub_sites[1] && 
        this.shiftDataService.selectedSiteSlaData[0].sub_sites[1].site_id ){
      siteIds.push(this.shiftDataService.selectedSiteSlaData[0].sub_sites[0].site_id);
      siteIds.push(this.shiftDataService.selectedSiteSlaData[0].sub_sites[1].site_id);
    }
    this.dashboardService.getSLADaysDetails(siteIds).subscribe(
        (res: any) => {
          let summaryData = res;
          res.forEach((department)=>{
            this.department_asset_details.push({
                department_name: department.department_name,
                asset_count: 0
              });
          })
          // this.shiftDataService.filters = summaryData;
          //sort assets/sitename (filter) in ascending order
          // this.shiftDataService.sortAssetsAscendingOrder(summaryData);
          this.filters = summaryData;
          this.selectedAssetType = this.filters[0];
          this.filtersCopy = [...this.filters];
        },
        (error) => {
            // this.alertService.error(error.responseStatus.statusDescription);
        }
    );
   }

   department_name:any[]=[];

   onSelectFilterChange(asset: any,event:any) {

    this.department_asset_details.forEach((data:any) =>{
        if(this.selectedAssetType.department_name === data.department_name){
            if(event.checked){
                data.asset_count += 1;
            }
            else{
                data.asset_count -= 1;
            } 
        }
    })
    this.shiftDataService.selectedAssetIdsToEditSlaDays =
        this.shiftDataService.selectedAssetIdsToEditSlaDays.filter(
            (a) => +a.asset_id == +asset.asset_id
        ).length > 0
            ? this.shiftDataService.selectedAssetIdsToEditSlaDays.filter(
                  (a) => +a.asset_id != +asset.asset_id
              )
            : [...this.shiftDataService.selectedAssetIdsToEditSlaDays, asset];
            this.saveBtnEnable = (this.newSLADay > 0 && this.shiftDataService.selectedAssetIdsToEditSlaDays.length > 0) ? false : true ;
        }
onAssetTypeClick(assetType, checked, skipEmit = false) {
    this.filters
        // .filter((at) => at.asset_type_id == assetType.asset_type_id)[0]
        .filter((at) => at.department_name == assetType.department_name)[0]
        .assets.forEach((asset) => {
            this.shiftDataService.selectedAssetIdsToEditSlaDays = !checked
                ? this.shiftDataService.selectedAssetIdsToEditSlaDays.filter(
                      (a) => +a.asset_id != +asset.asset_id
                  )
                : [
                      ...this.shiftDataService.selectedAssetIdsToEditSlaDays,
                      asset,
                  ];
        });
        this.saveBtnEnable = (this.newSLADay > 0 && this.shiftDataService.selectedAssetIdsToEditSlaDays.length > 0) ? false : true ;
        if (!skipEmit) {
        this.onAssetClick(assetType);
        // this.shiftDataService.onFilterChange.emit(
        //     this.shiftDataService.selectedAssetIdsForFilter
        // );
        // this.applyAssetFilters(this.shiftDataService.selectedAssetIdsForFilter);
    }
}

  isAssetTypeChecked(assetType) {
      let selectedAssets = [];
      assetType.assets.forEach((asset) => {
          if (
              this.shiftDataService.selectedAssetIdsToEditSlaDays.filter(
                  (a) => +a.asset_id == +asset.asset_id
              ).length
          ) {
              selectedAssets.push(asset);
          }
      });
      this.saveBtnEnable = (this.newSLADay > 0 && this.shiftDataService.selectedAssetIdsToEditSlaDays.length > 0) ? false : true ;
      return assetType.assets.length == selectedAssets.length ? true : false;
  }
  onSelectAllAssetsClick(checked) {
    this.department_asset_details.forEach((data:any) =>{
        if(this.selectedAssetType.department_name === data.department_name){
            if(checked){
                data.asset_count += this.selectedAssetType.assets.length;
            }
            else{
                if(data.asset_count > 0){
                    data.asset_count -= this.selectedAssetType.assets.length;
                }
            } 
        }
    })
    this.onAssetTypeClick(this.selectedAssetType, checked, false);
    this.saveBtnEnable = (this.newSLADay > 0 && this.shiftDataService.selectedAssetIdsToEditSlaDays.length > 0) ? false : true ;
}

  onSubmitClick() {
      this.shiftDataService.applyAssetFilters(
          this.shiftDataService.selectedAssetIdsToEditSlaDays,this.shiftDataService.selectIssueType
      );
      // if(this.shiftDataService && this.shiftDataService.selectedAssetIdsToEditSlaDays && this.shiftDataService.selectedAssetIdsToEditSlaDays.length > 0){
          localStorage.setItem('selectedIssueType',JSON.stringify(this.shiftDataService.selectIssueType));
      // }
      this.dialogRef.close();
  }

  isFilterEnabled(){
      return (this.shiftDataService.selectedAssetIdsToEditSlaDays.length > 0)? true : false ;
  }
  onCloseBtnClick(){
    this.dialogRef.close();
  }

  numberOFDaysEntered(value : number){
    this.newSLADay = value;
    this.saveBtnEnable = (this.newSLADay > 0 && this.shiftDataService.selectedAssetIdsToEditSlaDays.length > 0) ? false : true ;
}

  saveChanges(){
    let siteIds :any = [];
    if(this.shiftDataService && this.shiftDataService.selectedMasterSite.sub_sites[0] && this.shiftDataService.selectedMasterSite.sub_sites[0].site_id ){
      siteIds.push(this.shiftDataService.selectedMasterSite.sub_sites[0].site_id);
      siteIds.push(this.shiftDataService.selectedMasterSite.sub_sites[1].site_id);
    }
    // sla_days:0,department_name1:'',asset_id: 0,site_ids: ''
    let asset_id :any = [];
    this.shiftDataService.selectedAssetIdsToEditSlaDays.forEach((assets) =>{
        asset_id.push(assets.asset_id)
    })
    let department_name :any = [];
    this.department_asset_details.forEach((data : any)=>{
        if(data.asset_count > 0){
            department_name.push(data.department_name);
        }
    })
    department_name = department_name.toString();
    this.dashboardService.updateSLADays(this.newSLADay,asset_id,this.selectedAssetType.site_ids,department_name).subscribe(
      (res: any) => {
        this.shiftDataService.siteSelectionEvent.emit();
      },
      (error) => {
        //   this.alertService.error(error.message);
      }
  );
    this.dialogRef.close();
}
}
